import client from "../modules/client";
import HelperService from "./helper-service";

export const getList = (filter) => {
  return client(`/api/v1/events?lat=${filter?.lat}&lon=${filter?.lon}&radius=${HelperService.getRadius(filter)}`).then(({ data }) => data);
};

export const getUserList = (userID, filter={}) => {
   let query = HelperService.getFilterQueryString({
    from: filter.from || (new Date()).getTime() - 3600*1000,
    upcoming: filter.upcoming || 1,
  });
  return client(`/api/v0/users/${userID}/events?${query}`).then(({ data }) => data?.events);
};

export const getUserPastList = (userID, filter={}) => {
   let query = HelperService.getFilterQueryString({
    from: filter.from || (new Date()).getTime() - 3600*1000,
    upcoming: filter.upcoming || 0,
  });
  return client(`/api/v0/users/${userID}/events?${query}`).then(({ data }) => data?.events);
};

export const getDetail = (id) => {
  return client(`/api/v0/events/${id}`).then(({ data }) => data?.class );
};

export const getEsDetail = (esid) => {
  return client(`/api/v0/classes/temp/${esid}?datetimeFrom=${(new Date()).getTime()}`).then(({ data }) => data?.class );
};

export const getAttendeeList = (eventId) => {
  return client(`/api/v0/events/${eventId}/attendees`).then(({ data }) => data?.attendees );
};

export const createAttendance = ({eventId, type, paymentIntentId,focusTargets=[]}) => {
  return client(`/api/v0/events/${eventId}/attendees`, {method:"post", body: {type: type, code: null, focusTargets: focusTargets, paymentIntentId: paymentIntentId}}).then(({ data }) => data );
};

export const cancelAttendance = (eventId, uid) => {
  return client(`/api/v0/events/${eventId}/attendees/${uid}`, {method:"delete"}).then(({ data }) => data );
};

export const createReview = (eventId, {text, review}) => {
  return client(`/api/v0/events/${eventId}/reviews`, {method:"post", body: {text:text, review:review}}).then(({ data }) => data );
};

export const requestRefund = (eventId, uid) => {
  return client(`/api/v0/events/${eventId}/attendees/${uid}/requestRefund`, {method:"post", body: {}}).then(({ data }) => data );
};

export const tip = (eventId, paymentIntentId) => {
  return client(`/api/v0/events/${eventId}/tip`, {method:"post", body: {paymentIntentID: paymentIntentId}}).then(({ data }) => data );
};

export function useEventService () {
  return {
    getList,
    getDetail,
    getEsDetail,
    getUserList,
    getUserPastList,
    getAttendeeList,
    createAttendance,
    cancelAttendance,
    createReview,
    requestRefund,
    tip,
  };
}
